import React from 'react';
import { EOrganization } from 'lib/types';
import { State } from 'lib/enums';

type InvoiceFormPaperInfoTableProps = {
  organization: EOrganization;
};

function InvoiceFormPaperInfoTable({
  organization
}: InvoiceFormPaperInfoTableProps) {
  const { address, name, city, state, zipCode } = organization;
  return (
    <div className="bg-white shadow rounded-lg px-4 py-5">
      <h2 className="font-bold">Publisher</h2>
      <p>{name}</p>
      <address className="not-italic">
        <span>
          {address} <br /> {city} {State.by_value(state)?.abbrev.toUpperCase()},{' '}
          {zipCode}
        </span>
      </address>
    </div>
  );
}

export default InvoiceFormPaperInfoTable;
